import {
    addErrorClass,
    addLoadingClass,
    removeLoadingClass
} from "../../../../default/global/js/utilities/updateClasses";
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";
import {initSlidecontents} from "../../../../default/global/js/slidecontent";

export function initAjaxCollectionMultiFilterSearch(multiFilteringPage) {
    const wrapperId = multiFilteringPage.getAttribute("id");
    const area = multiFilteringPage.querySelector(".collectionArea");
    const multiSelectWrapper = multiFilteringPage.querySelector(".js-collection-multiselect");
    const collectionSearchForm = multiFilteringPage.querySelectorAll(".js-collection-searchform");
    const tagsWrapper = multiSelectWrapper.querySelector(".js-collectionFilterSettings");
    let searchString = "";
    initSearchForm(collectionSearchForm, () => {
        fetchResults(wrapperId, area, tagsWrapper);
    });
    buildSelect(multiSelectWrapper, tagsWrapper);
    setActiveClassForMultiFilter(multiFilteringPage, tagsWrapper);
    if (area) {
        initClickEvents(multiFilteringPage, area, tagsWrapper, wrapperId);
        initBreadcrumbClicks(multiFilteringPage, area, tagsWrapper, wrapperId);
    }

    function initSearchForm(forms, fetchResultsCallback) {
        forms.forEach(form => {
            searchString = form.querySelector('.js-collectionSearchInput').value;
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                const input = form.querySelector('.js-collectionSearchInput');
                searchString = input.value;
                multiFilteringPage.querySelectorAll('.js-collectionSearchInput').forEach((input) => {
                    input.value = searchString;
                });
                fetchResultsCallback();
            });
        });

    }
    function initBreadcrumbClicks(multiFilteringPage, area, tagsWrapper, wrapperId) {
        multiFilteringPage.addEventListener("click", (e) => {
            const breadcrumbItem = e.target.closest(".pagination__item ");
            if (!breadcrumbItem) return;
            e.preventDefault();
            addLoadingClass(area);
            const page = new URL(breadcrumbItem.href).searchParams.get('page') || '1';
            const fetchSegment = getGroupFilterQueryString({page});
            fetchData(fetchSegment)
                .then(data => updateContent(data, wrapperId, area, breadcrumbItem, fetchSegment, tagsWrapper))
                .catch(error => handleError(error, area));
            /*   const filterID = btn.dataset.filter;
               const fetchSegment = getGroupFilterQueryString(filterID);
               fetchData(fetchSegment)
                   .then(data => updateContent(data, wrapperId, area, btn, fetchSegment, tagsWrapper))
                   .catch(error => handleError(error, area));*/
        });
    }
    function initClickEvents(multiFilteringPage, area, tagsWrapper, wrapperId) {
        multiFilteringPage.addEventListener("click", (e) => {
            const btn = e.target.closest(".js-collectionFilter .tag");
            if (!btn) return;
            e.preventDefault();
            addLoadingClass(area);
            const filterID = btn.dataset.filter;
            const fetchSegment = getGroupFilterQueryString({item:filterID});
            fetchData(fetchSegment)
                .then(data => updateContent(data, wrapperId, area, btn, fetchSegment, tagsWrapper))
                .catch(error => handleError(error, area));
        });
    }

    function fetchResults(wrapperId, area, tagsWrapper) {
        const fetchSegment = getGroupFilterQueryString(null);
        fetchData(fetchSegment)
            .then(data => updateContent(data, wrapperId, area, null, fetchSegment, tagsWrapper))
            .catch(error => handleError(error, area));
    }

    function fetchData(url) {
        return fetch(url).then(response => {
            if (!response.ok) throw new Error("Could not filter data");
            return response.text();
        });
    }

// Update content with fetched data
    function updateContent(data, wrapperId, area, btn, fetchSegment, tagsWrapper) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const newWrapper = doc.getElementById(wrapperId);

        if (!newWrapper) throw new Error('Wrapper not found');
        const newArea = newWrapper.querySelector(".collectionArea");

        if (!newArea) throw new Error('Area not found');

        area.innerHTML = newArea.innerHTML;
        area.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
        // if (btn) removeLoadingClass(btn);
        removeLoadingClass(area);
        window.history.replaceState(null, null, fetchSegment);
        setActiveClassForMultiFilter(multiFilteringPage, tagsWrapper);
    }

    function handleError(error, area) {
        console.error('Error:', error);
        addErrorClass(area);
    }

    function buildSelect(multiSelectWrapper, tagsWrapper) {
        const options = getOptionsFromJsonString(multiSelectWrapper.dataset.options);
        if (!options.groups) return;

        const slideContentDiv = document.createElement('div');
        slideContentDiv.className = 'slidecontent';
        /**
         * {"groups":[{"title":"Kategorie","keysExcept":[18,17,19]},{"title":"Schwierigkeit","keys":[18,17,19]}]}
         */
        options.groups.forEach(group => {
            const copiedElement = tagsWrapper.cloneNode(true);
            const spans = Array.from(copiedElement.querySelectorAll('.tag'));

            // Filter spans based on keys or keysExcept
            spans.forEach(span => {
                const filterValue = parseInt(span.getAttribute('data-filter'), 10);
                if ((group.keys && !group.keys.includes(filterValue)) || (group.keysExcept && group.keysExcept.includes(filterValue))) {
                    span.remove();
                }
            });

            // If keys array exists, sort the spans according to the order in keys
            if (group.keys) {
                const sortedSpans = spans.filter(span => {
                    const filterValue = parseInt(span.getAttribute('data-filter'), 10);
                    return group.keys.includes(filterValue);
                }).sort((a, b) => {
                    const aValue = parseInt(a.getAttribute('data-filter'), 10);
                    const bValue = parseInt(b.getAttribute('data-filter'), 10);
                    return group.keys.indexOf(aValue) - group.keys.indexOf(bValue);
                });

                // Clear the copiedElement and append the sorted spans
                copiedElement.textContent = "";
                sortedSpans.forEach(span => copiedElement.appendChild(span));
            }

            const slideContentItemDiv = createSlideContentItem(group.title, copiedElement);
            slideContentDiv.appendChild(slideContentItemDiv);
        });

        multiSelectWrapper.appendChild(slideContentDiv);
        initSlidecontents();
        tagsWrapper.textContent = "";
    }

// Create slide content item
    function createSlideContentItem(title, content) {
        const slideContentItemDiv = document.createElement('div');
        slideContentItemDiv.className = 'slidecontentItem slidecontentItem--withArrows';

        const headlineTag = document.createElement('h3');
        headlineTag.className = 'slidecontentItem__headline';

        const headlineButton = document.createElement('button');
        headlineButton.setAttribute("aria-expanded", "false");
        headlineButton.setAttribute("aria-controls", "slidecontent_"+title);
        headlineButton.id="slidecontrols_"+title;
        headlineButton.textContent = title;

        headlineTag.appendChild(headlineButton);

        const contentDiv = document.createElement('div');
        contentDiv.className = 'slidecontentItem__content';
        contentDiv.setAttribute("role", "region");
        contentDiv.setAttribute("aria-labelledby", "slidecontrols_"+title);
        contentDiv.id="slidecontent_"+title;

        contentDiv.appendChild(content);

        slideContentItemDiv.appendChild(headlineTag);
        slideContentItemDiv.appendChild(contentDiv);
        return slideContentItemDiv;
    }

    function setActiveClassForMultiFilter(multiFilteringPage, tagsWrapper) {
        const checkedButtons = [];
        tagsWrapper.textContent = "";

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const paramValue = params.get("group_filter");


            const items = paramValue ? paramValue.split(','):[];
            multiFilteringPage.querySelectorAll(".js-collectionFilter .tag").forEach(btn => {
                btn.classList.remove("is-active");
                const filterId = btn.dataset.filter;
                if (items.includes(filterId)) {
                    btn.classList.add("is-active");
                    if (!checkedButtons.includes(filterId)) {
                        const copiedElement = btn.cloneNode(true);
                        copiedElement.classList.add('is-closeable');
                        tagsWrapper.appendChild(copiedElement);
                        checkedButtons.push(filterId);
                    }
                }
            });

        //if (searchString && searchString.length > 0) {
        collectionSearchForm.forEach(form => {
            const searchTagWrapper = form.querySelector('.js-collection-searchTermWrapper');
            searchTagWrapper.textContent = "";
            if (searchString && searchString.length > 0) {
                const newSearchTag = document.createElement('span');
                newSearchTag.className = 'tag is-closeable';
                newSearchTag.textContent = GLOBALS.tc.search + ": " + searchString;
                newSearchTag.addEventListener("click", () => {
                    form.querySelector('.js-collectionSearchInput').value = "";
                    let event = new Event("submit", {bubbles: true, cancelable: true});
                    form.dispatchEvent(event);
                });
                searchTagWrapper.appendChild(newSearchTag);
            }

            //searchString= form.querySelector('.js-collectionSearchInput').value;
        });
        //}
    }


    function getGroupFilterQueryString(config) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const {page= params.get('page'),item=null}=config??{};

        let paramValueGroupFilter = params.get('group_filter');

        if (paramValueGroupFilter && item) {
            const items = paramValueGroupFilter.split(',');
            if (items.includes(item)) {
                paramValueGroupFilter = items.filter(i => i !== item).join(',');
            } else {
                items.push(item);
                paramValueGroupFilter = items.join(',');
                params.set('group_filter', paramValueGroupFilter);
            }
        } else if (item && item.length > 0) {
            paramValueGroupFilter = item;
            params.set('group_filter', paramValueGroupFilter);
        }

        if (paramValueGroupFilter) {
            params.set('group_filter', paramValueGroupFilter);
        } else {
            params.delete('group_filter');
        }
        if (searchString && searchString.length > 0) {
            params.set('search', searchString);
        } else {
            params.delete('search');
        }


        if(page > 1){
            params.set('page',page);
        }
        else{
            params.delete('page');
        }

        return `?${params.toString()}`;

    }
}

